import {
	isChrome,
	isChromium,
	isIOS,
	isIOS13,
	isIPod13,
	isAndroid,
	isDesktop,
	isMobile,
	isEdge,
	isOpera,
	isSafari,
} from 'react-device-detect';

import { DEVICE_TYPE } from '../types/deviceType';

export function useDeviceService() {
	const getDeviceType = function () {
		if (isIOS13 || isIOS || isIPod13) {
			return DEVICE_TYPE.IOS;
		} else if (isAndroid) {
			return DEVICE_TYPE.ANDROID;
		} else if (isDesktop && (isChrome || isChromium)) {
			return DEVICE_TYPE.DESKTOP_CHROME;
		} else if (isDesktop) {
			return DEVICE_TYPE.DESKTOP;
		}
	};

	const isBrowserDeviceAuthorized = function () {
		return (
			isMobile ||
			(isDesktop && (isChrome || isChromium || isEdge || isOpera || isSafari))
		);
	};

	return { getDeviceType, isBrowserDeviceAuthorized };
}
